import React from 'react'
import {
  FaBoxes,
  FaStore,
  FaArrowUp,
  FaArrowDown,
  FaMinus,
  FaCoins,
} from 'react-icons/fa'
import { TbRadar2, TbPackageExport } from 'react-icons/tb'
import { MdTrendingUp } from 'react-icons/md'
import { KpiGrid, KpiCard } from './styles'
import { SkuKpis } from './types'

interface SkuKpisGridProps {
  kpis: SkuKpis
}

const formatMoney = (val: number) => {
  return (val || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  })
}

const formatNumber = (val: number) => {
  return (val || 0).toLocaleString('pt-BR')
}

export const SkuKpisGrid: React.FC<SkuKpisGridProps> = ({ kpis }) => {
  const comp = kpis?.comparativo || ({} as any)

  const renderDelta = (delta: number, suffix = '%') => {
    if (delta === undefined || delta === null || isNaN(delta)) return null
    if (delta > 0) {
      return (
        <span className='delta positive'>
          <FaArrowUp size={10} /> +{delta}
          {suffix} vs anterior
        </span>
      )
    }
    if (delta < 0) {
      return (
        <span className='delta negative'>
          <FaArrowDown size={10} /> {delta}
          {suffix} vs anterior
        </span>
      )
    }
    return (
      <span className='delta neutral'>
        <FaMinus size={10} /> 0{suffix} estável
      </span>
    )
  }

  return (
    <KpiGrid>
      <KpiCard $highlight={true}>
        <div className='card-top'>
          <span className='label'>Média SKUs / PDV</span>
          <div className='icon-pill'>
            <TbRadar2 />
          </div>
        </div>
        <div className='card-main'>
          <div className='value'>{kpis.mediaSkusPorPdv?.toFixed(1) || '0.0'} SKUs</div>
          {renderDelta(comp.mediaSkusPorPdvDelta, ' SKUs')}
        </div>
        <div className='card-footer'>Profundidade de mix por cliente positivado</div>
      </KpiCard>

      <KpiCard>
        <div className='card-top'>
          <span className='label'>Venda Média / PDV</span>
          <div className='icon-pill'>
            <FaCoins />
          </div>
        </div>
        <div className='card-main'>
          <div className='value'>{formatMoney(kpis.vendaMediaPorSkuVl)}</div>
          {renderDelta(comp.vendaMediaPorSkuVlDelta)}
        </div>
        <div className='card-footer'>Faturamento médio por item ativo no período</div>
      </KpiCard>

      <KpiCard>
        <div className='card-top'>
          <span className='label'>Volume Médio / SKU</span>
          <div className='icon-pill'>
            <TbPackageExport />
          </div>
        </div>
        <div className='card-main'>
          <div className='value'>{formatNumber(kpis.volumeMedioPorSkuCx)} Cx</div>
          {renderDelta(comp.volumeMedioPorSkuCxDelta)}
        </div>
        <div className='card-footer'>Caixas faturadas em média por SKU ativo</div>
      </KpiCard>

      <KpiCard>
        <div className='card-top'>
          <span className='label'>SKUs Ativos no Mix</span>
          <div className='icon-pill'>
            <FaBoxes />
          </div>
        </div>
        <div className='card-main'>
          <div className='value'>{formatNumber(kpis.skusAtivos)} itens</div>
          {renderDelta(comp.skusDelta)}
        </div>
        <div className='card-footer'>Produtos distintos com vendas registradas</div>
      </KpiCard>

      <KpiCard>
        <div className='card-top'>
          <span className='label'>PDVs Positivados</span>
          <div className='icon-pill'>
            <FaStore />
          </div>
        </div>
        <div className='card-main'>
          <div className='value'>{formatNumber(kpis.totalPdvsPositivados)}</div>
          {renderDelta(comp.pdvsDelta)}
        </div>
        <div className='card-footer'>Clientes que compraram no período selecionado</div>
      </KpiCard>

      <KpiCard>
        <div className='card-top'>
          <span className='label'>Faturamento Total</span>
          <div className='icon-pill'>
            <MdTrendingUp />
          </div>
        </div>
        <div className='card-main'>
          <div className='value'>{formatMoney(kpis.totalFaturamento)}</div>
          {renderDelta(comp.faturamentoDelta)}
        </div>
        <div className='card-footer'>{formatNumber(kpis.totalCaixas)} caixas líquidas vendidas</div>
      </KpiCard>
    </KpiGrid>
  )
}
